<!-- 本页面目前只有第一屏和最后两屏接入后台，其他的不支持后台数据 -->
<template>
  <div class="HomeModular">
    <nav-bar :onIndex="0"></nav-bar>
    <div class="Content">
      <div class="banner" v-if="bannerInfo">
        <div class="video">
          <video class="javaVideo" autoplay loop muted>
            <source
              class="javaSource"
              src="./images/banner_video.mp4"
              type="video/mp4"
            />
          </video>
          <div class="bannerfont">
            <div>
              <img src="./images/baner_font.png" width="827px" alt="" />
            </div>
            <div
              style="margin-top: 50px; cursor: pointer"
              @click="handleVideo('https://v.itheima.net/xmsz.mp4')"
              v-log="['首页banner视频播放', '开始']"
            >
              <div class="banPlayBut">
                <img
                  src="../../../../assets/btn_play_ban.png"
                  width="27px"
                  alt=""
                />
                播放实战视频
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="subNavList" id="scrollTag">
        <div class="navList" :class="{ scrollTag: scrollTag }">
          <div class="navListBox">
            <div
              class="item"
              v-for="(item, index) in navData"
              :key="index"
              @click="scrollAimsHandle(index)"
              v-show="index != 3 && index != 2"
            >
              <div
                v-log="['首页导航', '9大热门学科']"
                class="font"
                :class="{ tag: tagInd == index }"
              >
                <span
                  >{{ item.title
                  }}<i v-if="index != 0 && index != 5">+</i></span
                >
              </div>
              <div
                v-log="['首页导航', '70+主流行业']"
                class="subfont"
                v-show="index == 0 || index == 3 || index == 5"
              >
                {{ item.subtit }}
              </div>
              <div
                v-log="['首页导航', '240+专家团队']"
                class="subfont"
                v-show="index == 1"
              >
                覆盖70<i>+</i>主流行业
              </div>
              <div
                v-log="['首页导航', '研发经费']"
                class="subfont"
                v-show="index == 2"
              >
                240<i>+</i>人的专家团队
              </div>
              <div
                v-log="['首页导航', '精品项目']"
                class="subfont"
                v-show="index == 4"
              >
                100<i>+</i>精品项目
              </div>
              <div
                v-log="['首页导航', '课程实施']"
                class="subfont"
                v-show="index == 6"
              >
                7000<i>+</i>次课程实施
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg1" class="screen sTwo">
        <div class="centent">
          <div class="title">选择学科 体验真项目</div>
          <div class="desc">七大热门学科，完备的知识体系任由你选择</div>
          <div class="cont">
            <div class="itemContes" style="margin-top: 50px">
              <div class="items">
                <div
                  class="item"
                  v-for="(item, index) in sTwoFirstRowData"
                  :key="index"
                  @click="goSubjectHome(item.url)"
                  v-log="['首页项目体验', item.title]"
                >
                  <div class="name">{{ item.title }}</div>
                  <div class="desc">{{ item.desc }}</div>
                  <div class="subjectLog">
                    <img :src="item.image" height="190px" alt="" />
                  </div>
                  <div class="more">查看更多</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg2" class="screen sTree">
        <div class="centent">
          <div class="title">
            <span>70<i>+</i> </span> 主流行业 全覆盖
          </div>
          <div class="desc" style="color: #616a72">
            众领域经验在手 任市场千帆变化
          </div>
          <div :class="{ cont: true, streeKeyformShow: streeKeyformShow }">
            <img src="./images/1@2x.png" width="100%" alt="" />
            <img src="./images/3@2x.png" width="100%" alt="" />
            <img src="./images/2@2x.png" width="100%" alt="" />
          </div>
        </div>
      </div>
      <!-- 违禁词原因整个模块下掉 -->
      <!-- <div id="scrollTg3" class="screen sFour">
            <div class="centent">
                <div class="title"><span>240<i>+</i></span>专家团队 匠心打造</div>
                <div class="cont" >
                    <div class="subTit"> 名企顾问团队<span>100余人</span> </div>
                    <div class="contA" :class="{showRoundA: showRoundA}">
                        <div class="leftBox">
                            <div class="des">传智教育自06年成立，已与<em>华为、百度、京东、创新工场</em>等百余家企业形成战略合作伙伴，100余位行业专家进行业务指导、方向把控、技术方案指导，以保障项目业务场景及技术应用与企业应用匹配度，保障学员所学即所用。</div>
                        </div>
                        <div class="rightBox">
                            <img src="./images/img_logo_wai.png" width="100%" alt="">
                        </div>
                    </div>
                    <div class="subTit" > 传智专家团队<span>140余人</span> </div>
                    <div class="contB" :class="{showRound: showRound}" >
                        <div class="item itemA">
                            <div class="topBox bgA">
                                <img src="./images/img_v2_a.png" width="100%" alt="">
                            </div>
                            <div class="labBox">
                            </div>
                            <div class="des">
                                团队由<em>商业调研员、需求分析师、高级产品经理</em>共计18人组成。以保障项目的商业模式、业务模式、产品架构设计真实性、合理性，避免学员所学项目与企业应用场景相差甚远。
                            </div>
                        </div>
                        <div class="item itemB">
                            <div class="topBox bgB">
                                <img src="./images/img_v2_b.png" width="100%" alt="">
                            </div>
                            <div class="labBox">
                            </div>
                            <div class="des">
                                团队成员来自<em>IBM、华为、百度、腾讯、阿里</em>等一线大厂，由CTO、高级架构师、高级开发工程师、高级视觉设计师、高级测试工程师、项目经理组成，以<em>前沿技术预判、难点技术攻关</em>为主，确保项目的前沿性、企业的适用性、技术方案的合理性。
                            </div>
                        </div>
                        <div class="item itemC">
                            <div class="topBox bgC">
                                <img src="./images/img_v2_c.png" width="100%" alt="">
                            </div>
                            <div class="des">
                                团队由<em>教学经验＞8年的技术</em>课程讲师组成，依据多年教学及<em>课程设计</em>经验，将技术专家团队研发的项目转化为学员<em>易吸收、好理解、干货足的项目课程</em>，保障学员在学习中掌握项目核心知识，能完成完整项目开发。
                            </div>
                        </div>
                        <div class="item itemD">
                            <div class="topBox bgD">
                                <img src="./images/img_v2_d.png" width="100%" alt="">
                            </div>
                            <div class="labBox">
                            </div>
                            <div class="des">
                                团队由是互联网市场多领域<em>技术专家</em>组成，熟悉业务场景、精通开发及课程设计方法，具备多年教学经验，完成项目<em>课程品质把控</em>工作，为课程输出做好终极把关。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
      </div> -->
      <!-- 违禁词原因整个模块下掉 -->
      <!-- <div id="scrollTg4" class="screen sFives">
            <div class="centent">
                <div class="title"><span>1亿<i>+</i></span> 研发投入 重金锻造</div>
                <div class="cont" :class="{sFivesContAnim:sFivesContAnim}">
                   <div class="wgTop">
                       <img src="./images/img_yanfatouru.png" width="100%" alt="">
                   </div>
                </div>
            </div>
      </div>   -->
      <div id="scrollTg5" class="screen sSix">
        <div class="centent">
          <div class="title">
            <span>100<i>+</i></span> 精品项目 精雕细琢
          </div>
          <div class="desc">
            我们一直秉承工匠精神，项目的每一个环节都是精心打造
          </div>
          <div class="cont" :class="{ sSixKeys: sSixKeys }">
            <div class="sixLift">
              <div class="infoBox">
                <div class="sixInfo">
                  <p><em>17</em>个岗位角色的精细化分工</p>
                  <p>5大阶段、<em>47</em>道工序的锻造打磨</p>
                  <p><em>21</em>次评审、9次验收的层层把关</p>
                  <p>百余次上千小时的研讨掌舵</p>
                  <p>上万学员、上百家企业的应用调研、市场分析</p>
                  <p>每个新项目研发历经一年周期</p>
                  <p>每个项目每年3次大版本升级，<em>50</em>余次小版本迭代</p>
                  <p>每个项目<i>上百万</i>的斥资打造</p>
                </div>
                <!-- <div class="sixInfoBut"><span></span>只为锻造精品、培养优秀的你</div> -->
              </div>
            </div>
            <div class="sixRit">
              <img src="./images/img_pro.png" width="100%" alt="" />
              <div class="info">
                <div
                  class="more"
                  @click="() => (openBigImg = true)"
                  v-log="['首页精品项目', '查看流程']"
                >
                  查看流程
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg6" class="screen sSeven" v-if="eighthScreen">
        <div class="centent">
          <div class="guideCont">
            <img src="./images/img_guide.png" width="100%" alt="" />
            <div class="guideOne">
              <img src="./images/img_guide_go.png" width="56px" alt="" />
            </div>
          </div>
          <div class="title">
            <span>{{ eighthScreen.info }}</span> {{ eighthScreen.title }}
          </div>
          <div class="cont">
            <div class="sevItems" :class="{ sevItemsKeys: sevItemsKeys }">
              <div class="labCont">
                <div
                  :class="{ lab: true, act: programState == index }"
                  v-for="(item, index) in eighthScreen.contListDataes"
                  @click="checkHandle(index)"
                  :key="index + 99"
                  v-log="['20年教学精华模块', item.title]"
                >
                  {{ item.title }}
                </div>
              </div>
              <div
                class="item"
                :class="{
                  show: index == programState,
                  hide: index != programState,
                }"
                v-for="(item, index) in eighthScreen.contListDataes"
                :key="index"
              >
                <div class="iconLab">
                  <img
                    class="iconImg"
                    src="./images/Teaching method.png"
                    width="162px"
                    alt=""
                  />
                  <div class="info">
                    <div class="ButInfo">
                      <div class="tit">{{ item.title }}</div>
                      <div class="lab">{{ item.subTitle }}</div>
                      <ul>
                        <li
                          v-for="(it, ind) in item.desc.split('|')"
                          :key="ind"
                        >
                          {{ it }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="bigImg">
                  <div
                    class="banPlayBut"
                    v-if="item.vidUrl && index == 0"
                    @click="handleVideo(item.vidUrl)"
                  >
                    <img
                      src="../../../../assets/btn_play_ban.png"
                      width="27px"
                      alt=""
                    />
                    播放案例课程
                  </div>
                  <div
                    class="banPlayBut"
                    v-if="item.vidUrl && index == 2"
                    @click="handleVideo(item.vidUrl)"
                  >
                    <img
                      src="../../../../assets/btn_play_ban.png"
                      width="27px"
                      alt=""
                    />
                    播放实战视频
                  </div>
                  <img
                    :src="item.image[0].url"
                    width="100%"
                    v-if="item.image.length"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 最后一屏 项目滚动 - 接入后台 -->
      <div id="scrollTg7" class="screen sEight" v-if="ninthScreen">
        <div class="topbg">
          <img src="./images/bg_e_rt.png" width="252" alt="" />
        </div>
        <div class="centent">
          <div class="title">
            <span>7000<i>+</i></span> {{ ninthScreen.title }}
          </div>
          <div class="cont">
            <div class="sEightBox">
              <div class="sEightTopCont">
                <div class="leftImg">
                  <img src="./images/img_cls.png" width="100%" alt="" />
                </div>
                <div class="ritInfo">
                  <div class="infoCont">
                    <div class="item bias" style="width: 180px">
                      <p>
                        <em>{{ ninthScreen.info.split('，')[1] }}</em
                        ><span class="add">+</span>
                      </p>
                      <p><span>班级实施</span></p>
                    </div>
                    <div class="item bias">
                      <p>
                        <em>{{ ninthScreen.info.split('，')[2] }}</em
                        ><span class="add">+</span>
                      </p>
                      <p><span>学员演练</span></p>
                    </div>
                    <div class="item">
                      <p>
                        <em>{{ ninthScreen.info.split('，')[3] }}</em
                        ><span class="add">+</span>
                      </p>
                      <p><span>学员实战</span></p>
                    </div>
                  </div>
                  <div class="des">
                    {{ ninthScreen.url }}
                  </div>
                </div>
              </div>
              <div class="linkList">
                <div class="linkListRollCont">
                  <div
                    :class="{ rollBox: true, rollOpen: rollOpen }"
                    @mouseover="rollOpenHandle('st')"
                    @mouseout="rollOpenHandle()"
                  >
                    <div
                      class="list"
                      @click="goDetails(item.url)"
                      v-for="(item, index) in ninthScreen.contListDataes"
                      :key="index + 10"
                      v-log="['首页项目列表', item.title]"
                    >
                      【{{ item.title }}】{{ item.desc }}
                    </div>
                    <div
                      class="list"
                      @click="goDetails(item.url)"
                      v-for="(item, index) in ninthScreen.contListDataes"
                      :key="index"
                      v-log="['首页项目列表', item.title]"
                    >
                      【{{ item.title }}】{{ item.desc }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="scrollTg8" class="screen sNine">
        <img src="./images/buttomImg.png" height="291px" alt="" />
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
    <bottom-widge></bottom-widge>
    <el-dialog :visible.sync="openBigImg" top="10%" width="1300px">
      <div class="HomeDialogCont">
        <div class="closeTag" @click="() => (openBigImg = false)">
          <img src="./../../../../assets/common/img/close.png" width="15px" />
        </div>
        <img src="./images/img_process_big.png" width="100%" alt="" />
        <div class="mapArea">
          <div class="area"></div>
          <div class="showInfo">
            <p>开发验收</p>
            <p>业务验收</p>
            <p>设计验收</p>
            <p>性能验收</p>
            <p>安全验收</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import navBar from './../../../components/navBar';
import bottomWidge from './../../../components/bottomWidge';
import { JavaHome } from '../../../../gqlapi/JavaHome.js';
import MenuAdd from './../../../components/video';
export default {
  name: 'layout',
  components: {
    navBar,
    bottomWidge,
    MenuAdd,
  },
  data() {
    return {
      bannerInfo: {},
      tagInd: 99,
      scrollTag: false,
      openBigImg: false,
      streeKeyformShow: false,
      rollOpen: false,
      showRound: false,
      sFivesContAnim: false,
      showRoundA: false,
      sSixKeys: false,
      sevItemsKeys: false,
      SecondScreen: null,
      ThirdScreen: null,
      fourthScreen: null,
      fifthScreen: null,
      sixthScreen: null,
      eighthScreen: null,
      ninthScreen: null,
      navData: [
        { title: '7', subtit: '7大热门学科' },
        { title: '70', subtit: '项目库覆盖70大行业' },
        { title: '240', subtit: '240人的专家团队', sp: true },
        //   {title: '1亿', subtit: '年上亿研发经费投入'},
        {},
        { title: '100', subtit: '100个经典项目', sp: true },
        { title: '20', subtit: '20年教学经验积淀' },
        { title: '7000', subtit: '', sp: true },
      ],
      sTwoFirstRowData: [
        {
          title: 'AI智能应用',
          desc: '用AI重构企业级应用',
          image: require('./images/java.png'),
          url: '/java',
        },
        {
          title: 'AI大模型',
          desc: '顺势而为、AI创新未来',
          image: require('./images/ai.png'),
          url: '/ai',
        },
        {
          title: '前端',
          desc: '视野所及，唯有前端',
          image: require('./images/web.png'),
          url: '/web',
        },
        //   {
        //       title: 'Python',
        //       desc: '通用编程语言，助你掌控未来',
        //       image: require('./images/python.png'),
        //       url: '/python'
        //   },
        {
          title: 'AI测试',
          desc: '智能时代的质检大师',
          image: require('./images/img_QA 2@2x.png'),
          url: '/testHome',
        },
        {
          title: 'AI大数据',
          desc: '站在云端操控万千数据',
          image: require('./images/data.png'),
          url: '/bigdata',
        },
        {
          title: '新媒体',
          desc: '做新时代的“弄潮儿”',
          image: require('./images/bg_xmt.png'),
          url: '/nm',
        },
        {
          title: 'AI设计',
          desc: '设计，让世界更美丽',
          image: require('./images/ui.png'),
          url: '/ui',
        },
        // {
        //   title: '产品经理',
        //   desc: '产品之父，互联网产品规划师',
        //   image: require('./images/img_pm.png'),
        //   url: '/pm',
        // },
      ],
      sSevenDataes: [
        {
          bgImage: require('./images/bg_sev_a.jpg'),
          title: 'OPEN教学法',
          desc: '结构完整、有效的授课框架确保你学的懂，学得会',
          subTitle: '四个步骤，讲解每套理论',
          rollList: [
            { title: 'Objective 抛出问题，激发学员兴趣', url: '' },
            { title: 'Path 设计学员当前知识的学习路径', url: '' },
            { title: 'Experience 互动式讲解，保障学习体验 ', url: '' },
            { title: 'Note 知识回顾，沟通反馈，加强学习效果', url: '' },
          ],
        },
        {
          bgImage: require('./images/bg_sev_b.jpg'),
          title: '场景式教学',
          desc: '在既定的业务场景下展开技能学习， 深入浅出，学以致用',
          subTitle: '业务场景和应用方法，让你活学活用',
          rollList: [
            { title: '模拟多种多样真实的企业场景', url: '' },
            { title: '技术讲授紧密结合业务场景梳理', url: '' },
            { title: '教你如何应用匹配的技术方案', url: '' },
          ],
        },
        {
          bgImage: require('./images/bg_sev_c.jpg'),
          title: '情景式授课',
          desc: '根据认知规律，将故事情景和知识融为一体，加强对知识的理解和吸收',
          subTitle: '三步走，让专业概念通俗易懂',
          rollList: [
            { title: '引入故事场景，培养兴趣', url: '' },
            { title: '知识结合剧情，易于吸收', url: '' },
            { title: '加大知识延展，便于掌握', url: '' },
          ],
        },
        {
          bgImage: require('./images/bg_sev_d.jpg'),
          title: '项目实战式教学',
          desc: '在实际企业分工模式下，开展项目团队配合开发',
          subTitle: '软硬技术双向加强，提前进入大企氛围',
          rollList: [
            { title: '还原企业业务模式', url: '' },
            { title: '还原企业工作流程', url: '' },
            { title: '还原企业技术应用', url: '' },
            { title: '还原企业工作工具', url: '' },
            { title: '还原企业项目角色', url: '' },
            { title: '还原企业团队协作', url: '' },
          ],
        },
      ],
      sEightDataes: [
        {
          title: 'AI智能应用',
          desc: '黑马头条项目   实施 27个班级 就业1458名学员',
          url: '/black',
        },
        {
          title: '大数据',
          desc: '星途车联网项目   实施 6个班级 就业300名学员',
          url: '/xingtu-bigdata',
        },
        {
          title: '前端 学科',
          desc: '黑马面面项目   实施10个班级 就业505名学员',
          url: '/mianmian-fontend',
        },
        {
          title: 'AI设计',
          desc: '裕园茶电商项目   实施8个班级 就业410名学员',
          url: '/sj-yycd',
        },
        {
          title: 'AI 大模型',
          desc: '智慧交通项目   实施 7个班级 就业250名学员',
          url: '/jiaotong-ai',
        },
        // {
        //   title: '产品经理学科',
        //   desc: '尚学教务项目   实施 12个班级 就业578名学员',
        //   url: '/pm-sxjw',
        // },
        {
          title: 'Python+数据分析',
          desc: '黑马头条项目   实施 12个班级 就业600名学员',
          url: '/toutiao-python',
        },
        {
          title: 'AI测试',
          desc: 'Ego微商项目   实施 5个班级 就业262名学员',
          url: '/cs-ego',
        },
        {
          title: 'Python+数据分析学科',
          desc: '十次方项目   实施 8个班级 就业400名学员',
          url: '/shicifang-python',
        },
        {
          title: 'AI智能应用',
          desc: '探花交友项目   实施 36个班级 就业1836学员',
          url: '/tanhua',
        },
        {
          title: 'AI智能应用',
          desc: '黑马头条项目   实施 27个班级 就业1458名学员',
          url: '/black',
        },
        {
          title: '大数据',
          desc: '星途车联网项目   实施 6个班级 就业300名学员',
          url: '/xingtu-bigdata',
        },
        {
          title: '前端 学科',
          desc: '黑马面面项目   实施10个班级 就业505名学员',
          url: '/mianmian-fontend',
        },
        {
          title: 'AI设计',
          desc: '裕园茶电商项目   实施8个班级 就业410名学员',
          url: '/sj-yycd',
        },
        {
          title: 'AI 大模型',
          desc: '智慧交通项目   实施 7个班级 就业250名学员',
          url: '/jiaotong-ai',
        },
        // {
        //   title: '产品经理学科',
        //   desc: '尚学教务项目   实施 12个班级 就业578名学员',
        //   url: '/pm-sxjw',
        // },
        {
          title: 'Python+数据分析',
          desc: '黑马头条项目   实施 12个班级 就业600名学员',
          url: '/toutiao-python',
        },
        {
          title: 'AI测试',
          desc: 'Ego微商项目   实施 5个班级 就业262名学员',
          url: '/cs-ego',
        },
        {
          title: 'Python+数据分析学科',
          desc: '十次方项目   实施 8个班级 就业400名学员',
          url: '/shicifang-python',
        },
        {
          title: 'AI智能应用学科',
          desc: '探花交友项目   实施 36个班级 就业1836学员',
          url: '/tanhua',
        },
      ],
      swiperOptionMain: {
        direction: 'vertical',
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 2000,
        },
      },
      baseInfo: {
        baseInfoTitle1: '',
        baseInfoTitle2: '',
        baseInfoDesc1: '',
        baseInfoDesc2: '',
        pVideoUrl: '',
        videoLogoImage: '',
      },
      programState: 0,
    };
  },
  created() {
    this.getJavaHomeDataes();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollHandle);
  },
  methods: {
    // 初始化数据获取
    getJavaHomeDataes() {
      // this.$apollo.query({
      //   query: JavaHome,
      //   variables: {
      //     id: 2
      //   }
      // })
      this.$axios
        .post('/api', {
          operationName: 'JavaHome',
          variables: {
            id: 2,
          },
          query: JavaHome,
        })
        .then((res) => {
          const data = res.data.data.javaHome;
          this.bannerInfo = data.FirstScreen;
          this.SecondScreen = data.SecondScreen;
          this.ThirdScreen = data.ThirdScreen;
          this.fourthScreen = data.fourthScreen;
          this.fifthScreen = data.fifthScreen;
          this.sixthScreen = data.sixthScreen;
          this.eighthScreen = data.eighthScreen;
          this.eighthScreen.contListDataes.forEach((el, i) => {
            if (i == 0) {
              el.vidUrl = 'http://v.itheima.com/07udpfsd2.mp4';
            } else if (i == 2) {
              el.vidUrl = 'https://v.itheima.net/xmsz.mp4';
            }
          });
          this.ninthScreen = data.ninthScreen;
        })
        .catch((res) => {
          console.log('JavaHome 请求出错：' + res);
        });
    },
    // 点击前往学科主页
    goSubjectHome(url) {
      // window.scrollTo({ 'top': 0, 'behavior': 'smooth' });
      window.open(url, '_blank');
      // this.$router.push(url)
    },
    checkHandle(ind) {
      setTimeout(() => {
        this.programState = ind;
      }, 100);
    },
    goDetails(url) {
      console.log(url);
      if (url) {
        let routeUrl = this.$router.resolve({
          path: url,
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    qimoChatClick(name) {
      this.$trackEvent(name, '点击图标', name);
      window.qimoChatClick();
    },
    scrollHandle() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let tagSc = document.querySelector('#scrollTag');
      let tag2 = document.querySelector('#scrollTg2');
      // let tag3 = document.querySelector('#scrollTg3');
      // let tag4 = document.querySelector('#scrollTg4');
      let tag5 = document.querySelector('#scrollTg5');
      let tag6 = document.querySelector('#scrollTg6');
      let tag7 = document.querySelector('#scrollTg7');
      if (scrollTop >= tagSc.offsetTop - 35) {
        this.scrollTag = true;
        this.tagInd = 0;
      } else if (scrollTop < tagSc.offsetTop - 35) {
        this.scrollTag = false;
        this.tagInd = 99;
      }
      if (scrollTop >= tag2.offsetTop - 620) {
        this.streeKeyformShow = true;
      }
      // if (scrollTop >= tag3.offsetTop - 620){
      //     this.showRoundA = true;
      // }
      // if (scrollTop >= tag3.offsetTop){
      //     this.showRound = true;
      // }
      // if (scrollTop >= tag4.offsetTop - 620){
      //     this.sFivesContAnim = true
      // }
      if (scrollTop >= tag5.offsetTop - 620) {
        this.sSixKeys = true;
      }
      if (scrollTop >= tag6.offsetTop - 620) {
        this.sevItemsKeys = true;
      }
      if (scrollTop >= tag2.offsetTop - 100) {
        this.tagInd = 1;
      }
      // if (scrollTop >= tag3.offsetTop - 100){
      //     this.tagInd = 2
      // }
      // if (scrollTop >= tag4.offsetTop - 100){
      //     this.tagInd = 3
      // }
      if (scrollTop >= tag5.offsetTop - 100) {
        this.tagInd = 4;
      }
      if (scrollTop >= tag6.offsetTop - 100) {
        this.tagInd = 5;
      }
      if (scrollTop >= tag7.offsetTop - 100) {
        this.tagInd = 6;
      }
    },
    scrollAimsHandle(aims) {
      let aimsIdTag = document.querySelector('#scrollTag');
      let aimsId1 = document.querySelector('#scrollTg2');
      // let aimsId2 = document.querySelector('#scrollTg3');
      // let aimsId3 = document.querySelector('#scrollTg4');
      let aimsId4 = document.querySelector('#scrollTg5');
      let aimsId5 = document.querySelector('#scrollTg6');
      let aimsId6 = document.querySelector('#scrollTg7');
      switch (aims) {
        case 0: {
          window.scrollTo({ top: aimsIdTag.offsetTop, behavior: 'smooth' });
          break;
        }
        case 1: {
          window.scrollTo({ top: aimsId1.offsetTop - 100, behavior: 'smooth' });
          break;
        }
        // case 2: {
        //     window.scrollTo({ 'top': aimsId2.offsetTop-100, 'behavior': 'smooth' })
        //     break;
        // }
        // case 3: {
        //     window.scrollTo({ 'top': aimsId3.offsetTop-100, 'behavior': 'smooth' })
        //     break;
        // }
        case 4: {
          window.scrollTo({ top: aimsId4.offsetTop - 100, behavior: 'smooth' });
          break;
        }
        case 5: {
          window.scrollTo({ top: aimsId5.offsetTop - 100, behavior: 'smooth' });
          break;
        }
        case 6: {
          window.scrollTo({ top: aimsId6.offsetTop - 100, behavior: 'smooth' });
          break;
        }
      }
    },
    rollOpenHandle(st) {
      if (st == 'st') {
        this.rollOpen = true;
      } else {
        this.rollOpen = false;
      }
    },
    handleVideo(url, e) {
      this.baseInfo.pVideoUrl = url;
      window.event ? (window.event.cancelBubble = true) : e.stopPropagation();
      this.$refs.editMenu.dialogFormV(this.baseInfo);
    },
  },
};
</script>

<style src="./style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss">
.HomeModular .swiper-container {
  height: 50px;
}
.HomeModular .el-dialog__header {
  display: none;
}
.HomeModular .el-dialog {
  min-width: 1180px;
  max-width: 1440px;
  top: 50%;
  transform: translateY(-50%);
}
.HomeModular .HomeDialogCont {
  background: #fff;
  position: relative;
  .closeTag {
    position: absolute;
    cursor: pointer;
    right: 20px;
    top: 20px;
  }
  .mapArea {
    position: absolute;
    right: 12%;
    top: 38.5%;
    .area {
      position: absolute;
      background: red;
      opacity: 0;
      width: 100px;
      height: 20px;
      right: 0px;
      cursor: pointer;
    }
    .showInfo {
      position: relative;
      display: none;
      text-align: center;
      padding: 8px 0;
      top: 30px;
      width: 107px;
      font-size: 12px;
      color: #181818;
      line-height: 28px;
      opacity: 1;
      background: #ffffff;
      border-radius: 7px;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.07);
    }
    &:hover .showInfo {
      display: block;
    }
  }
}
@keyframes wordsLoopRow {
  0% {
    top: 0px;
  }
  100% {
    top: -200px;
  }
}
@keyframes wordsLoop {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-50%);
  }
}
@keyframes showRoundT {
  0% {
    opacity: 0;
    top: calc(50% - 40px);
    transform: rotate(0deg);
  }
  100% {
    opacity: 1;
    top: calc(32% - 40px);
    transform: rotate(360deg);
  }
}
@keyframes showRoundL {
  0% {
    opacity: 0;
    left: calc(50% - 40px);
    transform: rotate(0deg);
  }
  100% {
    opacity: 1;
    left: calc(38% - 40px);
    transform: rotate(360deg);
  }
}
@keyframes showRoundR {
  0% {
    opacity: 0;
    left: calc(50% - 40px);
    transform: rotate(0deg);
  }
  100% {
    opacity: 1;
    left: calc(62% - 40px);
    transform: rotate(360deg);
  }
}
@keyframes showRoundBT {
  0% {
    opacity: 0;
    top: calc(60% - 40px);
    transform: rotate(0deg);
  }
  100% {
    opacity: 1;
    top: calc(41% - 40px);
    transform: rotate(360deg);
  }
}

@keyframes showVsCardsL {
  0% {
    left: -100px;
    opacity: 1;
  }
  100% {
    left: 0;
    opacity: 1;
  }
}
@keyframes showVsCardsRit {
  0% {
    right: -100px;
    opacity: 0;
  }
  100% {
    right: 0px;
    opacity: 1;
  }
}
@keyframes showSwggerL {
  0% {
    left: -200px;
    opacity: 1;
  }
  100% {
    left: 0;
    opacity: 1;
  }
}
@keyframes showSwggerR {
  0% {
    right: -200px;
    opacity: 0;
  }
  100% {
    right: 0px;
    opacity: 1;
  }
}

@keyframes infiniteArrow {
  0% {
    opacity: 0;
    transform: translateY(0);
  }
  50% {
    opacity: 0.8;
    transform: translateY(20px);
  }
  100% {
    opacity: 0;
    transform: translateY(40px);
  }
}
@keyframes keyFromUpShow {
  0% {
    opacity: 0;
    top: 320px;
  }
  100% {
    opacity: 1;
    top: 220px;
  }
}
@keyframes keysUpShow {
  0% {
    opacity: 0;
    top: 100px;
  }
  100% {
    opacity: 1;
    top: 0px;
  }
}
@keyframes fontUpShow {
  0% {
    opacity: 0;
    top: 180px;
  }
  100% {
    opacity: 1;
    top: 80px;
  }
}
@keyframes bannerFontUpShow {
  0% {
    opacity: 0;
    top: 60%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
@keyframes sFivesKeys {
  from {
    height: 0;
  }
  to {
    height: 330px;
  }
}
@keyframes sFivesKeys1 {
  from {
    height: 0;
  }
  to {
    height: 130px;
  }
}
@keyframes sFivesShowFont {
  from {
    opacity: 0;
    transform: translateY(0%);
  }
  to {
    opacity: 1;
    transform: translateY(-50%);
  }
}
@keyframes sFivesShowFont1 {
  from {
    opacity: 0;
    transform: translateY(0%);
  }
  to {
    opacity: 1;
    transform: translateY(-30%);
  }
}
@keyframes sFivesShowFont2 {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes sFivesShowBear {
  from {
    opacity: 0;
    right: -130px;
  }
  to {
    opacity: 1;
    right: 30px;
  }
}
</style>
